/* import __COLOCATED_TEMPLATE__ from './appointments-subs-plan-detail.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

/**
 * AppointmentsSubsPlanDetail Component
 *
 * This component displays feature information and a CTA for an appointments
 * subscription plan.
 */
let AppointmentsSubsPlanDetailComponent = (_class = class AppointmentsSubsPlanDetailComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor3, this);
    _initializerDefineProperty(this, "dataApi", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
  }
  get formattedPrice() {
    const formattedPrice = this.formatter.currency(this.args.plan.priceInCent, this.args.plan.currencyCode, {
      maximumFractionDigits: 0
    } // no decimal places in subscription price
    );
    return this.intl.t('apptsUpsell.subscription.plan.price.perMonth', {
      price: formattedPrice
    });
  }
  get isFree() {
    return this.args.plan.priceInCent === 0;
  }
  get planUnit() {
    return this.isFree ? this.intl.t('apptsUpsell.subscription.plan.unit.free') : this.intl.t('apptsUpsell.subscription.plan.unit.paid');
  }
  selectPlanAndTrack() {
    if (this.args.selectPlan) {
      this.args.selectPlan(this.args.plan);
      this.dataApi.track('Click Page', {
        platform: 'web',
        page_name: this.args.pageNameForCDPTracking,
        item_clicked: this.args.plan.token,
        subscription_state: this.appointmentsSubscription.status,
        plan_token: this.appointmentsSubscription.planToken
      });
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectPlanAndTrack", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPlanAndTrack"), _class.prototype), _class);
export { AppointmentsSubsPlanDetailComponent as default };